import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Container,
  Card,
  CardHeader,
  CardBody,
  Table,
  Input,
  Accordion,
  AccordionItem,
  Collapse,
  Button,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DailyStatusModal from "../SupportDashboard/DailyStatusModal";
import QueryCard from "../../../Components/CPComponents/CPRegister/CPRegisterDataCard";
import { useDispatch, useSelector } from "react-redux";
import { GET_SupportDashboard } from "../../../slices/Dashboards/SupportDashboard/thunk";
import CPSupportDataCardSirEdit from "./../../../Components/CPComponents/CPDashboard/Support/CPSupportDataCardSirEdit";
import { useLocation } from "react-router-dom";
import { Filter, X, Settings } from "react-feather";
import classnames from "classnames";

const QueryRegister = () => {
  // State for filters
  const userType = localStorage.getItem("userType");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const moduleName = queryParams.get("moduleName");
  const [filterStatus, setFilterStatus] = useState([]);
  const [filterModule, setFilterModule] = useState([]);
  const [filterClient, setFilterClient] = useState([]);
  const [filterTodayStatus, setFilterTodayStatus] = useState([]);
  const [filterTicketUser, setFilterTicketUser] = useState([]);
  const [showTicketUser, setShowTicketUser] = useState(true);


  const [searchQuery, setSearchQuery] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [modalData, setModalData] = useState(null);

  // Mobile drawer state
  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);

  // Accordion states
  const [showStatus, setShowStatus] = useState(true);
  const [showModule, setShowModule] = useState(true);
  const [showClient, setShowClient] = useState(true);
  const [showTodayStatus, setShowTodayStatus] = useState(true);
  const [colA, setcolA] = useState(false);

  useEffect(() => {
    if (moduleName) {
      setFilterModule(moduleName);
    }
  }, [moduleName]);

  // Redux state
  const data = useSelector((state) => state.SupportDashboard.data);

  const loading = useSelector((state) => state.SupportDashboard.loading);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Load saved filters from localStorage on mount
  useEffect(() => {
    const raw = localStorage.getItem("supportFilters");
    if (!raw) return;
    try {
      const saved = JSON.parse(raw) || {};
      const toArray = (v) => (Array.isArray(v) ? v : v ? [v] : []);
      setFilterStatus(toArray(saved.filterStatus));
      setFilterModule(toArray(saved.filterModule));
      setFilterClient(toArray(saved.filterClient));
      setFilterTodayStatus(toArray(saved.filterTodayStatus));
      setFilterTicketUser(toArray(saved.filterTicketUser));
      setSearchQuery(saved.searchQuery || "");
    } catch (e) {
      console.warn("Invalid saved filters in localStorage");
    }
  }, []);

  // Handle button click (Open modal with data)
  const handleButtonClick = (dailyID, Row) => {
    if (dailyID) {
      setModalData(dailyID);
      setModalOpen(!modalOpen);
    } else {
      setModalOpen(!modalOpen);
      setModalData(null);
      setSelectedRow(Row);
    }
    dispatch(GET_SupportDashboard());
  };

  const handleCloseModal = () => {
    setModalOpen(!modalOpen);
    dispatch(GET_SupportDashboard());
  };

  // Local state to manage filtered data
  const [queriesData, setQueriesData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  // Fetch data on component mount
  useEffect(() => {
    dispatch(GET_SupportDashboard());
  }, [dispatch]);

  // Update local state when data from Redux changes
  useEffect(() => {
    if (data?.length > 0) {
      setQueriesData(data);
    }
  }, [data]);

  // Filter logic
  useEffect(() => {
    const computeFilteredData = () => {
      const filtered = queriesData?.filter((query) => {
        const matchesStatus =
          filterStatus.length === 0 ||
          filterStatus.includes(query?.CurrentStatus || "Not Updated");
        const matchesModule =
          filterModule.length === 0 || filterModule.includes(query?.Module);

        const matchesClient =
          filterClient.length === 0 || filterClient.includes(query?.LicensedTo);
        const matchesTodayStatus =
          filterTodayStatus.length === 0 ||
          filterTodayStatus.includes(query?.TodaysStatus);

        const matchesTicketUser =
          filterTicketUser.length === 0 ||
          filterTicketUser.includes(query?.TicketUser);

        const matchesSearch =
          searchQuery === "" ||
          (query?.TicketNumber || "")
            .toString()
            .toLowerCase()
            .includes(searchQuery) ||
          (query?.Subject || "").toString().toLowerCase().includes(searchQuery);

        return (
          matchesStatus &&
          matchesModule &&
          matchesClient &&
          matchesTodayStatus &&
          matchesTicketUser &&
          matchesSearch
        );
      });

      setFilteredData(filtered);
    };
    computeFilteredData();
  }, [
    queriesData,
    filterStatus,
    filterModule,
    filterClient,
    filterTodayStatus,
    filterTicketUser, // ADD THIS LINE - This was missing!
    searchQuery,
  ]);

  // Compute counts for selected statuses
  const selectedStatusCounts = filterStatus.map((status) => {
    const count = filteredData.filter(
      (q) => (q?.CurrentStatus || "Not Updated") === status
    ).length;
    return { status, count };
  });

  const handleClearFilters = () => {
    setFilterStatus([]);
    setFilterModule([]);
    setFilterClient([]);
    setFilterTicketUser([]);
    setFilterTodayStatus([]);
    setSearchQuery("");
    localStorage.removeItem("supportFilters");
  };

  const uniqueStatuses = [
    ...new Set(
      queriesData?.map((query) => query?.CurrentStatus || "Not Updated")
    ),
  ];
  const uniqueModules = [
    ...new Set(queriesData?.map((query) => query?.Module)),
  ];
  const uniqueClients = [
    ...new Set(queriesData?.map((query) => query?.LicensedTo)),
  ];
  const uniqueTodayStatus = [
    ...new Set(queriesData?.map((query) => query?.TodaysStatus)),
  ];

  const uniqueTicketUsers = [
    ...new Set(queriesData?.map((query) => query?.TicketUser)),
  ];

  // Filter toggle function
  const toggleFilterSelection = (setter, value) => {
    setter((prev) => {
      const arr = Array.isArray(prev) ? prev : prev ? [prev] : [];
      if (arr.includes(value)) return arr.filter((v) => v !== value);
      return [...arr, value];
    });
  };

  // Save filters to localStorage
  useEffect(() => {
    const filtersToSave = {
      filterStatus,
      filterModule,
      filterClient,
      filterTodayStatus,
      searchQuery,
      filterTicketUser,
    };
    localStorage.setItem("supportFilters", JSON.stringify(filtersToSave));
  }, [
    filterStatus,
    filterModule,
    filterClient,
    filterTodayStatus,
    filterTicketUser,
    searchQuery,
  ]);

  // Accordion toggle
  const t_colA = () => {
    setcolA(!colA);
  };

  // Filter Content Component (Reusable for both desktop and mobile)
  const FilterContent = () => (
    <div className="filter-content">
      <Row className="gy-2 gx-3 align-items-start">
        {/* Ticket User */}
        <Col md="6" lg="3" className="mb-3">
          <div className="d-flex justify-content-between align-items-center bg-light p-2 rounded border">
            <small className="fw-semibold text-muted">Ticket User</small>
            <Filter
              size={16}
              className="text-secondary"
              onClick={() => setShowTicketUser((prev) => !prev)}
              style={{ cursor: "pointer" }}
            />
          </div>
          <Collapse isOpen={showTicketUser}>
            <div
              className="border rounded p-1 mt-1"
              style={{ maxHeight: "120px", overflowY: "auto" }}
            >
              {uniqueTicketUsers?.map((user, i) => (
                <label
                  key={i}
                  className="d-flex justify-content-between align-items-center mb-0 small px-1 py-1"
                >
                  <span className="text-truncate">{user}</span>
                  <Input
                    type="checkbox"
                    checked={filterTicketUser.includes(user)}
                    onChange={() =>
                      toggleFilterSelection(setFilterTicketUser, user)
                    }
                    style={{ width: "16px", height: "16px" }}
                  />
                </label>
              ))}
            </div>
          </Collapse>
        </Col>

        {/* Current Status */}
        <Col md="6" lg="3" className="mb-3">
          <div className="d-flex justify-content-between align-items-center bg-light p-2 rounded border">
            <div className="d-flex justify-content-between align-items-center w-100">
              <small className="fw-semibold text-muted">Current Status</small>
              {selectedStatusCounts.length > 0 && (
                <div className="d-flex flex-wrap gap-1">
                  {selectedStatusCounts.map(({ status, count }) => (
                    <span
                      key={status}
                      className="badge bg-primary text-light"
                      style={{ fontSize: "0.7rem" }}
                    >
                      {status}: {count}
                    </span>
                  ))}
                </div>
              )}
            </div>
            <Filter
              size={16}
              className="text-secondary"
              onClick={() => setShowStatus((prev) => !prev)}
              style={{ cursor: "pointer" }}
            />
          </div>
          <Collapse isOpen={showStatus}>
            <div
              className="border rounded p-1 mt-1"
              style={{
                maxHeight: "120px",
                overflowY: "auto",
              }}
            >
              {uniqueStatuses?.map((status, i) => (
                <label
                  key={i}
                  className="d-flex justify-content-between align-items-center mb-0 small px-1 py-1"
                >
                  <span className="text-truncate">{status}</span>
                  <Input
                    type="checkbox"
                    checked={filterStatus.includes(status)}
                    onChange={() =>
                      toggleFilterSelection(setFilterStatus, status)
                    }
                    style={{ width: "16px", height: "16px" }}
                  />
                </label>
              ))}
            </div>
          </Collapse>
        </Col>

        {/* Module */}
        <Col md="6" lg="3" className="mb-3">
          <div className="d-flex justify-content-between align-items-center bg-light p-2 rounded border">
            <small className="fw-semibold text-muted">Module</small>
            <Filter
              size={16}
              className="text-secondary"
              onClick={() => setShowModule((prev) => !prev)}
              style={{ cursor: "pointer" }}
            />
          </div>
          <Collapse isOpen={showModule}>
            <div
              className="border rounded p-1 mt-1"
              style={{
                maxHeight: "120px",
                overflowY: "auto",
              }}
            >
              {uniqueModules?.map((mod, i) => (
                <label
                  key={i}
                  className="d-flex justify-content-between align-items-center mb-0 small px-1 py-1"
                >
                  <span className="text-truncate">{mod}</span>
                  <Input
                    type="checkbox"
                    checked={filterModule.includes(mod)}
                    onChange={() => toggleFilterSelection(setFilterModule, mod)}
                    style={{ width: "16px", height: "16px" }}
                  />
                </label>
              ))}
            </div>
          </Collapse>
        </Col>

        {/* Client (Support-Portal only) */}
        {userType === "Support-Portal" && (
          <Col md="6" lg="3" className="mb-3">
            <div className="d-flex justify-content-between align-items-center bg-light p-2 rounded border">
              <small className="fw-semibold text-muted">Client</small>
              <Filter
                size={16}
                className="text-secondary"
                onClick={() => setShowClient((prev) => !prev)}
                style={{ cursor: "pointer" }}
              />
            </div>
            <Collapse isOpen={showClient}>
              <div
                className="border rounded p-1 mt-1"
                style={{
                  maxHeight: "120px",
                  overflowY: "auto",
                }}
              >
                {uniqueClients?.map((client, i) => (
                  <label
                    key={i}
                    className="d-flex justify-content-between align-items-center mb-0 small px-1 py-1"
                  >
                    <span className="text-truncate">{client}</span>
                    <Input
                      type="checkbox"
                      checked={filterClient.includes(client)}
                      onChange={() =>
                        toggleFilterSelection(setFilterClient, client)
                      }
                      style={{
                        width: "16px",
                        height: "16px",
                      }}
                    />
                  </label>
                ))}
              </div>
            </Collapse>
          </Col>
        )}

        {/* Today Status */}
        <Col md="6" lg="3" className="mb-3">
          <div className="d-flex justify-content-between align-items-center bg-light p-2 rounded border">
            <small className="fw-semibold text-muted">Today's Status</small>
            <Filter
              size={16}
              className="text-secondary"
              onClick={() => setShowTodayStatus((prev) => !prev)}
              style={{ cursor: "pointer" }}
            />
          </div>
          <Collapse isOpen={showTodayStatus}>
            <div
              className="border rounded p-1 mt-1"
              style={{
                maxHeight: "120px",
                overflowY: "auto",
              }}
            >
              {uniqueTodayStatus?.map((tStat, i) => (
                <label
                  key={i}
                  className="d-flex justify-content-between align-items-center mb-0 small px-1 py-1"
                >
                  <span className="text-truncate">{tStat}</span>
                  <Input
                    type="checkbox"
                    checked={filterTodayStatus.includes(tStat)}
                    onChange={() =>
                      toggleFilterSelection(setFilterTodayStatus, tStat)
                    }
                    style={{ width: "16px", height: "16px" }}
                  />
                </label>
              ))}
            </div>
          </Collapse>
        </Col>

        {/* Search & Clear - Full width on mobile */}
        <Col xs="12" md="6" className="mb-3">
          <small className="fw-semibold text-muted mb-1 d-block">Search</small>
          <Input
            type="text"
            bsSize="sm"
            placeholder="Search Ticket / Subject"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value.toLowerCase())}
          />
        </Col>

        <Col xs="12" md="6" className="mb-3">
          <small className="fw-semibold text-muted mb-1 d-block invisible">
            Clear
          </small>
          <div className="d-flex gap-2">
            <button
              className="btn btn-sm btn-secondary flex-grow-1"
              onClick={handleClearFilters}
              style={{ height: "31px" }}
            >
              Clear Filters
            </button>
            {/* Mobile only - Close button */}
            <Button
              color="secondary"
              size="sm"
              className="d-md-none"
              onClick={() => setMobileFilterOpen(false)}
              style={{ height: "31px" }}
            >
              <X size={14} />
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Breadcrumb */}
          <BreadCrumb title="Support Register" />

          {/* Mobile Filter Button - Only visible on mobile */}
          <div className="d-md-none mb-3">
            <Button
              color="primary"
              className="w-100 d-flex align-items-center justify-content-center gap-2"
              onClick={() => setMobileFilterOpen(true)}
            >
              <Filter size={16} />
              Advanced Filters
              {(filterStatus?.length > 0 ||
                filterModule?.length > 0 ||
                filterTicketUser?.length > 0 ||
                filterClient?.length > 0 ||
                filterTodayStatus?.length > 0) && (
                <span className="badge bg-success ms-1">Filter Applied</span>
              )}
            </Button>
          </div>

          {/* Desktop Accordion - Only visible on desktop */}
          <div className="d-none d-md-block">
            <Accordion id="default-accordion-example" flush>
              <AccordionItem className="material-shadow mb-3">
                <h2 className="accordion-header" id="headingOne">
                  <button
                    className={classnames("accordion-button", {
                      collapsed: !colA,
                    })}
                    type="button"
                    onClick={t_colA}
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <span>Advanced Filters and Search</span>
                    {(filterStatus?.length > 0 ||
                      filterModule?.length > 0 ||
                      filterClient?.length > 0 ||
                      filterTodayStatus?.length > 0) && (
                      <span className="badge bg-success ms-2">
                        Filter Applied
                      </span>
                    )}
                  </button>
                </h2>
                <Collapse
                  isOpen={colA}
                  className="accordion-collapse mt-3"
                  id="collapseOne"
                >
                  <Table className="border shadow-none w-100">
                    <thead>
                      <tr>
                        <th colSpan="2">
                          <FilterContent />
                        </th>
                      </tr>
                    </thead>
                  </Table>
                </Collapse>
              </AccordionItem>
            </Accordion>
          </div>

          {/* Mobile Filter Drawer */}
          <Offcanvas
            isOpen={mobileFilterOpen}
            toggle={() => setMobileFilterOpen(false)}
            direction="end"
            style={{ width: "85%" }}
          >
            <OffcanvasHeader toggle={() => setMobileFilterOpen(false)}>
              <div className="d-flex align-items-center gap-2">
                <Settings size={18} />
                Advanced Filters
                {(filterStatus?.length > 0 ||
                  filterModule?.length > 0 ||
                  filterClient?.length > 0 ||
                  filterTodayStatus?.length > 0) && (
                  <span className="badge bg-success ms-2">Applied</span>
                )}
              </div>
            </OffcanvasHeader>
            <OffcanvasBody>
              <div className="p-2">
                <FilterContent />
              </div>
            </OffcanvasBody>
          </Offcanvas>

          {/* Results */}
          <Row className="mt-3">
            <Col xl={18}>
              <Table
                className="border shadow-none flex-grow-0"
                style={{ tableLayout: "fixed", width: "100%" }}
              >
                <tr>
                  {loading ? (
                    <p>Loading queries...</p>
                  ) : filteredData?.length > 0 ? (
                    <div>
                      <QueryCard
                        data={filteredData}
                        onButtonClick={handleButtonClick}
                        query={searchQuery}
                      />
                    </div>
                  ) : (
                    <p>No queries found for the selected filters.</p>
                  )}
                </tr>
              </Table>
            </Col>
          </Row>

          {/* Modal */}
          {modalOpen && (
            <DailyStatusModal
              modalOpen={modalOpen}
              modalData={modalData}
              selectedRow={selectedRow}
              onClose={handleCloseModal}
            />
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default QueryRegister;
